import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// @Mui
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

// @Redux
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers';
import { useAppDispatch } from '../../redux/store';
import { getLogin } from '../../redux/slices/user/ActionsAsync';
import { logginCRM } from '../../redux/slices/user';

/**
 * Entrada desde el CRM. El CRM abre esta página y, cuando ella le avisa que está lista,
 * le manda correo y contraseña por postMessage (solo al origen del CRM): nunca viajan en la URL.
 */
const getCrmOrigins = (): string[] => {
  try {
    return [new URL(process.env.REACT_APP_CRM_FRONT || '').origin];
  } catch (error) {
    return [];
  }
};

const CRM_ORIGINS = getCrmOrigins();

export function LoginFromCRM() {
  const { user } = useSelector((state: RootState) => state);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (user.user) {
      navigate('/budgets');
      return undefined;
    }

    const onMessage = async (event: MessageEvent) => {
      if (!CRM_ORIGINS.includes(event.origin)) return;
      if (event.source !== window.opener) return;

      const { type, email, password } = event.data || {};
      if (type !== 'cml-crm-login' || !email || !password) return;

      window.removeEventListener('message', onMessage);
      dispatch(logginCRM({ loginCRM: true }));
      // Esperar a que termine el inicio de sesión: si se navega antes, la sesión aún no existe y se vuelve a /login.
      await dispatch(getLogin({ email, password }));
      navigate('/budgets');
    };

    window.addEventListener('message', onMessage);

    // Avisar al CRM (solo a su origen) que ya se puede enviar la sesión.
    if (window.opener) {
      CRM_ORIGINS.forEach(origin => window.opener.postMessage({ type: 'cml-estimates-ready' }, origin));
    }

    return () => window.removeEventListener('message', onMessage);
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100vh',
        width: '100vw',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress />
    </Box>
  );
}
